import React from "react"
import { useNavigate } from "react-router-dom"
import { News } from "src/openapi"
import { ViewMore, Box, Image } from "src/UILibrary"

type Props = {
  item: News
  large?: boolean
}

export const NewsItem = ({ item, large }: Props) => {
  const navigate = useNavigate()
  return (
    <Box position="relative" height="100%" onClick={() => navigate(`/news/${item.id}`)}>
      <Image
        src={item.imageUrl as string}
        alt=""
        sx={{
          height: large ? "400px" : "200px",
          border: "1px solid",
          borderColor: "background.default",
          flex: 1,
          resizeMode: "cover",
          ":hover": { opacity: 0.8, cursor: "pointer" },
        }}
        imageStyle={{ width: "100%", height: "100%" }}
      />
      <ViewMore
        size="small"
        color="textSecondary"
        sx={{
          height: "40px",
          position: "absolute",
          left: 1,
          bottom: 0,
          px: 3,
          bgcolor: "rgba(34, 34, 34, 0.6)",
          width: {
            xl: "calc(100% - 2px)",
            md: "calc(100% - 2px)",
            sm: "calc(100% - 2px)",
            xs: "calc(100% - 2px)",
          },
          boxSizing: "border-box",
          alignItems: "center",
          ":hover": { opacity: 0.8, cursor: "pointer" },
        }}
      >
        {item.title}
      </ViewMore>
    </Box>
  )
}
